<template>
  <v-data-table
    :headers="header"
    :items="transportes"
    :fixed-header="true"
    :search="search"
    :items-per-page="50"
    item-key="id"
    class="elevation-2 table-full-screen mx-1"
    :height="ALTURA_TABELA"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <div class="d-flex ml-n2">
          <v-icon left>mdi-format-list-bulleted</v-icon>
          <p class="ma-0 subtitle-1 font-weight-medium">Lista de Transportes</p>
        </div>

        <v-spacer></v-spacer>

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisa"
          single-line
          hide-details
          clearable
          class="pr-5"
          style="max-width: 450px"
        ></v-text-field>

        <v-dialog persistent v-model="dialog" max-width="600px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark v-on="on" small>
              <v-icon left>mdi-plus</v-icon>
              <span>Novo</span>
            </v-btn>
          </template>

          <v-card style="border: 1px solid #fff">
            <v-toolbar dark color="#042333" height="50px">
              <v-btn icon dark @click="close">
                <v-icon>mdi-close</v-icon>
              </v-btn>

              <v-toolbar-title>{{ title }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text
              style="min-height: 67vh"
              class="pb-0 row ma-0 align-center"
            >
              <div class="col-12">
                <v-text-field
                  outlined
                  v-model="form.descricao"
                  label="Descrição*"
                  autofocus
                  :error-messages="errorDescricao"
                  @input="$v.form.descricao.$touch()"
                  @blur="$v.form.descricao.$touch()"
                  class="input-descricao"
                ></v-text-field>

                <v-text-field
                  outlined
                  v-model="form.placa"
                  label="Placa*"
                  v-mask="maskPlaca"
                  :error-messages="errorPlaca"
                  @blur="$v.form.placa.$touch()"
                  @keypress="errorPlacaUnica = false"
                ></v-text-field>

                <v-text-field
                  outlined
                  v-model="form.capacidade_carga"
                  label="Capacidade de Carga*"
                  v-currency="number"
                  suffix="Kg"
                  :error-messages="errorCapacidadeCarga"
                  @input="$v.form.capacidade_carga.$touch()"
                  @blur="$v.form.capacidade_carga.$touch()"
                  class="input-capacidade_carga"
                  ref="caca"
                ></v-text-field>
              </div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="white" @click="close()">Cancelar</v-btn>
              <v-btn color="#042333" dark @click="salvar">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:item.action="{ item }">
      <v-btn icon title="Editar Transporte" class="mr-2" @click="editar(item)">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>

      <v-btn icon title="Remover Transporte" @click="excluir(item)">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </template>

    <template v-slot:item.capacidade_carga="{ item }">
      {{ Helpers.formatarValor(item.capacidade_carga) }}
    </template>
  </v-data-table>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import DrpAPI from "../../../api/drp";
import { mask } from "vue-the-mask";
import { setValue } from "vue-currency-input";

export default {
  directives: { mask },
  data() {
    return {
      header: [
        { text: "#", value: "id", width: "80px", align: "center" },
        { text: "Descrição", value: "descricao" },
        { text: "Placa", value: "placa" },
        {
          text: "Capacidade de Carga",
          value: "capacidade_carga",
          width: "190px",
          align: "right",
        },
        {
          text: "Ações",
          value: "action",
          sortable: false,
          width: "100px",
          align: "right",
        },
      ],
      transportes: [],
      search: "",
      dialog: false,
      title: "Novo Transporte",
      form: {
        id: "",
        descricao: "",
        placa: "",
        capacidade_carga: "",
      },
      maskPlaca: {
        mask: "AAA-#C##",
        tokens: {
          "#": { pattern: /\d/ },
          X: { pattern: /[0-9a-zA-Z]/ },
          A: {
            pattern: /[a-zA-Z]/,
            transform: (v) => v.toLocaleUpperCase(),
          },
          C: {
            pattern: /[0-9a-zA-Z]/,
            transform: (v) => v.toLocaleUpperCase(),
          },
        },
      },
      number: {
        currency: null,
        distractionFree: { hideCurrencySymbol: false },
        precision: 0,
        allowNegative: false,
        valueAsInteger: true,
        autoDecimalMode: false,
      },
      errorPlacaUnica: false,
    };
  },
  validations: {
    form: {
      descricao: { required },
      placa: {
        required,
        unique() {
          if (this.errorPlacaUnica) return false;
          else return true;
        },
        minLength: minLength(8),
      },
      capacidade_carga: { required, minValue: 0 },
    },
  },
  computed: {
    errorDescricao() {
      const errors = [];
      if (!this.$v.form.descricao.$dirty) return errors;
      !this.$v.form.descricao.required &&
        errors.push("A descrição é Obrigatória.");
      return errors;
    },
    errorPlaca() {
      const errors = [];
      if (!this.$v.form.placa.$dirty) return errors;
      !this.$v.form.placa.required && errors.push("A placa é Obrigatória.");
      !this.$v.form.placa.minLength &&
        errors.push("A placa deve conter ter 8 caracteres.");
      !this.$v.form.placa.unique && errors.push("A placa já é cadastrada");
      return errors;
    },
    errorCapacidadeCarga() {
      const errors = [];
      if (!this.$v.form.capacidade_carga.$dirty) return errors;
      !this.$v.form.capacidade_carga.minValue &&
        errors.push("A capacidade de carga deve ser maior que 0.");
      !this.$v.form.capacidade_carga.required &&
        errors.push("A capacidade de carga Obrigatórie.");
      return errors;
    },
    ALTURA_TABELA() {
      const altura_config = '240px';
      const altura_parametrizacao = '185px';

      return this.$route.meta.layout == 'parametrizacao' ? `calc(100vh - ${altura_parametrizacao})` : `calc(100vh - ${altura_config})`;
    }
  },
  created() {
    this.listar();
  },
  methods: {
    listar() {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        idLogado: localStorage.getItem("id"),
      };
      DrpAPI.getTransporte(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);
          if (response.status == 200) {
            this.transportes = response.data.transporte;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },
    excluir(item) {
      if (confirm("Deseja remover aplicativo?")) {
        const headers = this.Helpers.iniciarRequisicao();
        const params = item.id;
        DrpAPI.deleteTransporte(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);
            if (response.status == 200) {
              this.transportes = response.data.transporte;
            }
          })
          .catch(() => {
            this.Helpers.logout();
          });
      }
    },
    editar(prop) {
      this.dialog = true;
      this.form.id = prop.id;
      this.form.descricao = prop.descricao;
      this.form.placa = prop.placa;
      this.form.capacidade_carga = this.Helpers.formatarValor(
        prop.capacidade_carga
      );
      this.title = "Editar Transporte";
      this.$v.$reset();
      if (this.$refs.caca) setValue(this.$refs.caca, prop.capacidade_carga);
    },
    salvar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();
        const params = this.form;
        if (!params.id) {
          DrpAPI.createTransporte(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);
              this.transportes = response.data.transporte;
              this.close();
            })
            .catch((e) => {
              if (e.response.data.errors) {
                this.errorPlacaUnica = true;
                this.$v.$reset();
                this.$v.$touch();
              } else {
                this.Helpers.logout();
              }
            });
        } else {
          DrpAPI.updateTransporte(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);
              this.transportes = response.data.transporte;
              this.close();
            })
            .catch((e) => {
              if (e.response.data.errors) {
                this.errorPlacaUnica = true;
                this.$v.$reset();
                this.$v.$touch();
              } else {
                this.Helpers.logout();
              }
            });
        }
      }
    },
    close() {
      this.title = "Novo Transporte";
      this.form = {
        id: "",
        descricao: "",
        placa: "",
        capacidade_carga: "",
      };
      this.dialog = false;
      this.$v.$reset();
    },
  },
};
</script>
